<template>
    <el-dialog
    width="600px"
    class="move-group"
    :title="title ? `「${title}」移动组` : '移动组' "
    :visible.sync="dialogShow"
    :modal-append-to-body="false"
    :append-to-body="true"
    @open="onOpen"
    @closed="onClosed">
      <el-scrollbar v-loading="loading" :native="false" class="scrollbar-view box" view-class="el-scrollbar-view">
        <div class="pr-md pl-md pt" style="height:100%;">
          <el-tree ref="groupTree" :data="groupData" :default-checked-keys="[groupid]" show-checkbox default-expand-all node-key="groupid" highlight-current :check-strictly="true" :props="defaultProps" @check-change="checkChange"></el-tree>
        </div>
      </el-scrollbar>
      <div slot="footer" class="text-center mb">
        <el-button class="extend" @click="dialogShow = false">取消</el-button>
        <el-button class="extend" type="primary" @click="submit">提交</el-button>
      </div>
    </el-dialog>

  </template>
  
  <script>
import { listGroupTreeApi, moveEquipToGroupApi } from "@/api/rms/rmsEquipApi";
export default {
  name: "MoveGroup",

  props: {
    show: {
      type: Boolean,
      default: false
    },
    groupid: {
      default: null
    },
    equipids: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      groupData: [],
      loading: false,
      defaultProps: {
        children: "children",
        label: "title"
      }
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    }
  },

  created() {
    // console.log(this.groupid, "xxxxxxxx");
    this.fetchData();
  },

  methods: {
    showDialog() {
      this.dialogShow = true;
    },
    onOpen() {
      this.fetchData();
    },
    onClosed() {
    },

    checkChange(node,checked) {
      if(checked) {
        this.$refs.groupTree.setCheckedKeys([node.groupid])
        this.$emit("check", node.groupid);
      }else {
        if(node.groupid == this.groupid) this.$emit("check", 0);
      }
    },

    fetchData() {
      this.loading = true;
      listGroupTreeApi().then(res => {
        this.loading = false;
        if (!res.errno) {
          this.groupData = res.data.list;
        }
      });
    },

    submit() {
      const params = {
        groupid: this.groupid,
        equipids: this.equipids
      };

      moveEquipToGroupApi(params).then(res => {
        if (!res.errno) {
          this.$message.success("移动成功");
          this.dialogShow = false;
          this.$emit('success')
        }else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
  
  <style lang="scss" scoped>
.move-group {
  .new-btn {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
.box {
  height: 300px;
  padding: 0;
}
</style>
<style lang="scss">
.move-group {
  .el-dialog > .el-dialog__body {
    padding: 0 0px 24px;
  }
  .el-tree-node {
    .el-tree-node__content {
      height: 100%;
      min-height: 36px;
    }
  }
}
</style>
